(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/react/shared-components/svs-logo.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/react/shared-components/svs-logo.js');

'use strict';

const Brand = svs.ui.ReactBrand;
const SvsLogo = () => React.createElement("div", {
  className: "margin-top-3"
}, React.createElement(Brand, {
  brand: "svenskaspel-twolines-neg",
  emblem: true
}), React.createElement("p", {
  className: "margin-top-1 margin-bottom-2"
}, "Spel fr\xE5n AB Svenska Spel"));
svs.playerLogin.sharedComponents.SvsLogo = SvsLogo;

 })(window);